import { createContext } from 'react'

interface ViewRedirectContextType {
  redirectToEltModelForm: (modelName: string) => void
  redirectToGoalConfigs: (dashboardViewId: string) => void
  redirectToGoalConfig: (goalConfigId: string) => void
  redirectToMe: () => void
}

export const ViewRedirectContext = createContext<ViewRedirectContextType>({
  redirectToEltModelForm: () => {
    throw new Error('ViewRedirectContext is not initialized')
  },
  redirectToGoalConfigs: () => {
    throw new Error('ViewRedirectContext is not initialized')
  },
  redirectToGoalConfig: () => {
    throw new Error('ViewRedirectContext is not initialized')
  },
  redirectToMe: () => {
    throw new Error('ViewRedirectContext is not initialized')
  },
})
